import { getUnit } from './catalog.js';
/**
 * The measurement system a recipe was written in, read from its units. Spoons and pieces say
 * nothing; a British recipe cannot be told from its units (it is mostly metric) – imports and
 * the author set `UK` explicitly.
 */
export function guessUnitSystem(unitCodes) {
    let metric = 0;
    let us = 0;
    for (const code of unitCodes) {
        const unit = code ? getUnit(code) : undefined;
        if (!unit || (unit.dimension !== 'MASS' && unit.dimension !== 'VOLUME'))
            continue;
        if (unit.system === 'METRIC')
            metric++;
        else if (unit.system === 'US')
            us++;
    }
    if (metric === 0 && us === 0)
        return null;
    return us > metric ? 'US' : 'METRIC';
}
/**
 * What a new account starts with, from the region of the browser (`en-US` → US, `en-GB` → UK,
 * everything else metric). Only a proposal: language and measurement system are two settings.
 */
export function defaultMeasurementSystem(browserLanguages) {
    for (const tag of browserLanguages ?? []) {
        const region = tag.split(/[-_]/)[1]?.toUpperCase();
        if (!region)
            continue;
        if (region === 'US' || region === 'LR' || region === 'MM')
            return 'US';
        if (region === 'GB')
            return 'UK';
        return 'METRIC';
    }
    return 'METRIC';
}
//# sourceMappingURL=unit-system.js.map